// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-card{
  background:#fff;
  border-radius:10px;
  padding:16px;
  box-shadow:0 2px 8px rgba(0,0,0,0.05);
}

.summary-header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:15px;
}

.summary-btn{
  border:1px solid #d1d5db;
  background:#fff;
  padding:5px 12px;
  border-radius:6px;
  font-size:13px;
}

.summary-grid{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:10px;
}

.summary-item{
  border-right:1px solid #eee;
}

.summary-item:last-child{
  border-right:none;
}

.label{
  font-size:13px;
  color:#6b7280;
}

.value{
  color:#2563eb;
  margin:3px 0;
}

.count{
  color:#9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ap_auto_app/Charts/Cards/SummaryCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".summary-card{\n  background:#fff;\n  border-radius:10px;\n  padding:16px;\n  box-shadow:0 2px 8px rgba(0,0,0,0.05);\n}\n\n.summary-header{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  margin-bottom:15px;\n}\n\n.summary-btn{\n  border:1px solid #d1d5db;\n  background:#fff;\n  padding:5px 12px;\n  border-radius:6px;\n  font-size:13px;\n}\n\n.summary-grid{\n  display:grid;\n  grid-template-columns:repeat(4,1fr);\n  gap:10px;\n}\n\n.summary-item{\n  border-right:1px solid #eee;\n}\n\n.summary-item:last-child{\n  border-right:none;\n}\n\n.label{\n  font-size:13px;\n  color:#6b7280;\n}\n\n.value{\n  color:#2563eb;\n  margin:3px 0;\n}\n\n.count{\n  color:#9ca3af;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
